<template>
  <div class="liu">
    <!-- 标题 -->
    <mt-header fixed title="业绩汇总" class="title1">
      <mt-button slot="left" icon="back" @click="agentBackClickHandler">返回</mt-button>
      <mt-button slot="right" @click="visible.search = true">更多</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <!-- 提示 -->
      <div class="top-box">
        <div>
          <span>{{ `${emptyStartDate} - ${emptyEndDate}` }}</span>
        </div>
        <div>
          <span>
            已注册 <span class="link">{{ myData.registerTotal }}</span> 人， 已达标
            <span class="link">{{ myData.reachTotal }}</span> 人
          </span>
        </div>
      </div>
      <!-- 空页 -->
      <div v-if="isShowEmptyData"></div>
      <!-- 列表信息 -->
      <div v-if="isShowListData" class="achi-info">
        <div class="info-list" v-for="(item, index) in myData.list" :key="index">
          <div class="list-date">
            <span>{{ item.statisticDate }}</span>
          </div>
          <div class="list-register" @click="jumpDetail(item.statisticDate, item.registerCount, 1)">
            <span>
              已注册 <span :class="setBlueClass(item.registerCount)">{{ item.registerCount }}</span> 人
            </span>
          </div>
          <div class="list-reach" @click="jumpDetail(item.statisticDate, item.reachCount, 2)">
            <span>
              已达标 <span :class="setBlueClass(item.reachCount)">{{ item.reachCount }}</span> 人
            </span>
          </div>
        </div>
      </div>
      <!-- 无数据占位图 -->
      <div v-if="isShowNoData">
        <div class="no-data">
          <img src="../assets/member-empty@3x.png" width="60%" />
          <div v-if="visible.dateWord">最近一周暂无业绩</div>
          <div v-else> {{ `${emptyStartDate}-${emptyEndDate} 暂无业绩` }}<span v-if="false"> 邀请好友</span></div>
          <div>点击右上角 <span @click="visible.search = true">更多</span> 查看更多业绩汇总信息</div>
        </div>
      </div>
    </div>
    <!-- 查询弹出框 -->
    <mt-popup class="agent-popup" v-model="visible.search" position="top" popup-transition="popup-fade">
      <div class="agent-content">
        <!-- 标题 -->
        <mt-header fixed title="筛选" class="title2"></mt-header>
        <!-- 内容 -->
        <div class="popup-content">
          <div class="content-box">
            <div>
              <span>注册时间</span>
            </div>
            <div class="no-border">
              <span class="date" @click="handleDateClick('startDate')">{{ myParam.startDate }}</span>
              -
              <span class="date" @click="handleDateClick('endDate')">{{ myParam.endDate }}</span>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="more-button">
          <span class="white" @click="visible.search = false">取消</span>
          <span class="blue" @click="handleSearchBtnClick">确定</span>
        </div>
      </div>
    </mt-popup>
    <!-- 日期控件 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="datePickerConfirmHandler"></mt-datetime-picker>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import { GetUserStatistic } from '@/api/user';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
import { formatDate } from '@/utils/utils';
import { CusToast } from '@/utils/CustomToast';
import { setTimeout } from 'timers';
export default {
  name: 'Achievement',
  data() {
    return {
      // 列表信息
      myData: {
        list: [],
        registerTotal: 0,
        reachTotal: 0,
        total: -1,
        scrollDisabled: true,
      },
      // 查询参数
      myParam: {
        startDate: formatDate(new Date(new Date().setDate(new Date().getDate() - 6))),
        endDate: formatDate(new Date()),
        pageNum: 1,
        pageSize: 16,
      },
      // picker时间
      picker: {
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: null,
        dateType: '',
      },
      // 显示开关
      visible: {
        search: false,
        dateWord: true,
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'achievementdetail') {
      this.$store.commit('setCache', 'Achievement');
    } else {
      this.$store.commit('delCache', 'Achievement');
    }
    next();
  },
  computed: {
    emptyStartDate() {
      return this.myParam.startDate.replace(/\-/g, '.');
    },
    emptyEndDate() {
      return this.myParam.endDate.replace(/\-/g, '.');
    },
    isShowEmptyData() {
      return this.myData.total === -1;
    },
    isShowListData() {
      return this.myData.total > 0 && (this.myData.registerTotal > 0 || this.myData.reachTotal > 0);
    },
    isShowNoData() {
      return this.myData.total > -1 && this.myData.registerTotal === 0 && this.myData.reachTotal === 0;
    },
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      this.getMyData();
    },
    // 通过接口获取数据
    getMyData() {
      Indicator.open();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      const tmpParam = {
        startDate: `${this.myParam.startDate} 00:00:00`,
        endDate: `${this.myParam.endDate} 23:59:59`,
        pageNum: this.myParam.pageNum,
        pageSize: this.myParam.pageSize,
      };
      GetUserStatistic(tmpParam)
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.myData.total = res.total;
            this.myData.list.push(...res.data.dataList);
            this.myData.registerTotal = res.data.registerTotal;
            this.myData.reachTotal = res.data.reachTotal;
            // 通过记录条数list.length和数据总数total判断是否查询出所有数据
            // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
            if (this.myData.list.length < this.myData.total) {
              this.myData.scrollDisabled = false;
            }
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          this.myData.list = [];
          this.myData.total = -1;
          this.myData.scrollDisabled = true;
          this.myParam.pageNum = 1;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据，让页数加1并继续获取数据
      if (this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
    // 跳页
    jumpDetail(date, count, type) {
      count && this.$router.push({ path: '/achievementdetail', query: { date, type } });
    },
    // 日期确定事件
    datePickerConfirmHandler(val) {
      // 根据选择的日期类型判断
      switch (this.picker.dateType) {
        // 开始日期
        case 'startDate':
          // 如果开始日期选择了一个大于当前查询结束日期
          if (val > new Date(this.myParam.endDate)) {
            // 则将查询结束日期自动置为今天的日期
            this.myParam.endDate = formatDate(new Date());
          }
          this.myParam.startDate = formatDate(val);
          break;
        // 结束日期
        case 'endDate':
          this.myParam.endDate = formatDate(val);
          break;
      }
    },
    // 单击日期事件
    handleDateClick(val) {
      // 设置日期类型
      this.picker.dateType = val;
      // 根据选择的日期类型判断
      switch (val) {
        // 开始日期
        case 'startDate':
          // 日期框显示的最大日期：2000-01-01
          this.picker.startDate = new Date('2000-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询开始日期
          this.picker.selectedDate = new Date(this.myParam.startDate);
          break;
        // 结束日期
        case 'endDate':
          // 日期框显示的最大日期：默认查询开始日期
          this.picker.startDate = new Date(this.myParam.startDate);
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询结束日期
          this.picker.selectedDate = new Date(this.myParam.endDate);
          break;
      }
      this.$refs.datePicker.open();
    },
    // 查询搜索单击事件
    handleSearchBtnClick() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 1.设置日期文字显示
      this.visible.dateWord = false;
      // 2.关闭查询窗口
      this.visible.search = false;
      // 3.打开滚动刷新
      this.myData.scrollDisabled = true;
      // 4.重置列表数据
      this.myData.list = [];
      // 5.重置翻页页数
      this.myParam.pageNum = 1;
      // 6.重置总数
      this.myData.total = -1;
      // 7. 加载数据
      this.getMyData();
    },
    // 返回按钮事件
    agentBackClickHandler() {
      window.location.href = 'protocol://android';
    },
    // 填充假数据
    fillFalseData() {
      this.myData.total = 100;
      Indicator.open();
      this.myData.scrollDisabled = true;
      setTimeout(() => {
        Indicator.close();
        for (let i = 0; i < this.myParam.pageSize; i++) {
          const tmpMonth = Math.floor(Math.random() * 12 + 1)
            .toString()
            .padStart(2, '0');
          const tmpDate = Math.floor(Math.random() * 31 + 1)
            .toString()
            .padStart(2, '0');
          const obj = {
            statisticDate: `2020-${tmpMonth}-${tmpDate}`,
            registerCount: Math.floor(Math.random() * 101),
            reachCount: Math.floor(Math.random() * 101),
          };
          this.myData.list.push(obj);
          if (this.myData.list.length < this.myData.total) {
            this.myData.scrollDisabled = false;
          }
        }
      }, 1500);
    },
    // 设置注册数/达标数的样式
    setBlueClass(val) {
      return val !== '0' ? 'link' : '';
    },
  },
  filters: {
    noYearDate(val) {
      return val.substring(5);
    },
  },
};
</script>
